import { AxiosResponse } from 'axios';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/Buttons/Button';
import classNames from 'classnames';
import {
  MESSAGE_STATUS,
  TransactionDetailsInGatewayResponse,
  useGetTransactionDetailsInGateway,
  useMessageContext,
  useWithdrawCancel
} from 'react-easyrocket';
import { memo } from 'react';
import { useModalContext } from 'src/hooks/useModalContext';
import { setWithdrawalInProgress } from 'src/utils/transactionTypeFromLS';

interface StatusCellProps {
  item: React.ReactNode;
  className?: string;
  status: number;
  type: number;
  id: string;
  transactionId: number;
}

const _StatusCell = ({ item, className, status, type, id, transactionId }: StatusCellProps) => {
  const { t } = useTranslation();
  const { openModal } = useModalContext();
  const { openMessage } = useMessageContext();
  const onSuccess = (response: AxiosResponse<TransactionDetailsInGatewayResponse, any>) => {
    if (response?.data?.formFields) {
      openModal('FORM_FIELDS', { props: { isWithdrawal: true, ...response.data } });
      return;
    }
    if (response?.data?.checkoutUrl) {
      localStorage.setItem('withdrawal', 'true');
      window.open(response.data.checkoutUrl, '_self');
      return;
    }
    openMessage?.(t('accountWalletWithdrawal.noFields'), MESSAGE_STATUS.INFO);
  };
  const { refetch } = useGetTransactionDetailsInGateway(id, { onSuccess, enabled: false });
  const { mutateAsync: withdrawCancel } = useWithdrawCancel({
    onSuccess: () => openMessage?.(t('messagesWithdraw.cancel'), MESSAGE_STATUS.SUCCESS)
  });

  const handleWithdrawClick = async () => {
    setWithdrawalInProgress();
    await refetch();
  };

  const handleWithdrawCancel = () => {
    withdrawCancel({ transactionId });
  };

  return (
    <td
      className={classNames(
        'px-6 py-2.5 text-wthap_table_text flex flex-col items-end',
        className
      )}>
      <p>{item}</p>
      {status === 8 && type === 1 ? (
        <Button
          mode="button-secondary"
          className="text-[16px] "
          title={`${t('general.withdraw')}`}
          onClick={handleWithdrawClick}>
          {t('general.withdraw')}
        </Button>
      ) : null}
      {status === 12 && type === 1 ? (
        <Button
          mode="button-secondary"
          className="text-[16px]  max-w-[200px] h-30"
          title={`${t('general.cancel')}`}
          onClick={handleWithdrawCancel}>
          {t('general.cancel')}
        </Button>
      ) : null}
    </td>
  );
};

export const StatusCell = memo(_StatusCell);
